<template>
  <vx-card>
    <vs-popup title="Configurations" :active.sync="configPopup">
      <vs-input
        class="w-full"
        label-placeholder="Company Name"
        v-model="companyName"
      ></vs-input
      ><br />
      <vs-input
        class="w-full"
        label-placeholder="Receipient Name"
        v-model="companyDetails.name"
      ></vs-input
      ><br />
      <vs-input
        class="w-full"
        label-placeholder="Username/Id Pengguna"
        v-model="companyDetails.username"
      ></vs-input
      ><br />
      <vs-input
        class="w-full"
        label-placeholder="Password/Kata Laluan"
        v-model="companyDetails.pwd"
      ></vs-input>

      <br /><br /><br />
    </vs-popup>
    <vs-row>
      <vs-col vs-type="flex" vs-justify="center" vs-w="6">
        <!-- <ejs-multiselect
          id="multiselect"
          :dataSource="unitSelection"
          v-model="selectedUnits"
          :fields="fields"
          popupHeight="400px"
          mode="CheckBox"
          :filtering="filtering"
          enableGroupCheckBox="true"
          showDropDownIcon="true"
          allowFiltering="true"
          filterType="contains"
          filterBarPlaceholder="Search"
          showSelectAll="true"
          placeholder="Select Assets"
        ></ejs-multiselect> -->

        <AssetsSelect
          @selected="
            (v) => {
              // $emit('selected', v);
              selectedUnits = v;
            }
          "
          :style="{ width: `500px` }"
          ref="assetSelect"
          :dataSource="unitSelection"
          :f="fields"
          :filtering="filtering"
        />
      </vs-col>
      <vs-col vs-type="flex" vs-justify="center" vs-w="6">
        <vs-button
          radius
          color="primary"
          type="gradient"
          icon-pack="feather"
          icon="icon-settings"
          @click="openConfigPanel()"
        ></vs-button>
      </vs-col>
    </vs-row>
    <br />

    <div class="flex flex-wrap items-center justify-between">
      <div class="flex items-center">
        <vs-button
          @click="generatePdf"
          class="mb-base mr-3"
          type="border"
          icon-pack="feather"
          icon="icon icon-download"
          >Download</vs-button
        >
      </div>
    </div>
    <b>PREVIEW</b>
    <vs-progress
      indeterminate
      color="primary"
      v-if="loading == true"
    ></vs-progress>
    <div class="flex flex-1 overflow-hidden">
      <vue-html2pdf
        class="overflow-auto"
        style="height: calc(100% - 55px); width: 803px"
        :show-layout="true"
        :float-layout="false"
        :enable-download="true"
        :preview-modal="false"
        :paginate-elements-by-height="1132"
        :filename="`${companyDetails.name} - IgeotechGPS Vendor Certificate`"
        :pdf-quality="2"
        :manual-pagination="false"
        pdf-format="a4"
        pdf-orientation="portrait"
        pdf-content-width="803px"
        ref="html2Pdf"
        @progress="onProgress($event)"
      >
        <section slot="pdf-content" style="font-size: 12px">
          <div style="width: 803px; height: 1122px" class="relative">
            <a href="https://igeotechgps.com" target="_blank">
              <img
                src="@/assets/images/logo/header.png"
                width="100%"
                style="object-fit: contain"
              />
            </a>

            <hr />
            <br />
            <div style="margin-left: 30px; margin-right: 20px">
              <p>
                <b>{{ todayDate }}</b>
              </p>
              <div
                class="invoice__recipient-info my-4"
                style="line-height: 0.5"
              >
                <p>
                  <b>{{ companyDetails.name }}</b>
                </p>
                <br /><br />
                <p><b>Kepada sesiapa yang berkenaan,</b></p>
              </div>
              <br />
              <h6>
                <b
                  ><u
                    >PER: SISTEM PEMANTAUAN GPS BAGI SYARIKAT
                    {{ companyName }}</u
                  >
                </b>
              </h6>

              <p>
                Merujuk kepada perkara di atas, pihak kami,
                <b>Igeotech (M) SDN BHD.</b>, ingin memaklumkan bahawa lori hak
                milik <b>{{ companyName }}</b> telah dipasang dengan alat
                pemantauan GPS (Global Positioning System) mengikut peraturan
                dan spesifikasi yang telah ditetapkan.
              </p>
              <div>
                <b>Akses Aplikasi Igeotechgps</b>
                <div class="row">
                  <a href="https://fleets.igeotechgps.com" target="_blank"
                    ><vs-list-item
                      icon="icon-globe"
                      icon-pack="feather"
                      title="WEB - https://fleets.igeotechgps.com"
                    ></vs-list-item>
                  </a>
                  <a
                    href="https://play.google.com/store/apps/details?id=com.igeotechgps"
                    target="_blank"
                    ><vs-list-item
                      icon="android"
                      title="ANDROID - Igeotechgps"
                    ></vs-list-item>
                  </a>
                  <a
                    href="https://apps.apple.com/app/igeotechgps/id1568827742"
                    target="_blank"
                  >
                    <vs-list-item
                      icon="apple"
                      title="iOS - Igeotechgps"
                    ></vs-list-item>
                  </a>
                  <a
                    href="https://appgallery.huawei.com/app/C107658761"
                    target="_blank"
                  >
                    <vs-list-item
                      icon="icon-smartphone"
                      icon-pack="feather"
                      title="Huawei - Igeotechgps"
                    ></vs-list-item>
                  </a>
                </div>
                <br />
                <b
                  >ID Log Masuk : {{ companyDetails.username }} | Kata Laluan :
                  {{ companyDetails.pwd }}</b
                >
                <br /><br />
                <b>Senarai Lori ({{ selectedUnits.length }})</b>
                <div class="row" style="margin-left: 10px; margin-right: 10px">
                  <span v-for="(unit, index) of selectedUnits" :key="index"
                    >{{ index + 1 }}. {{ unit }} &nbsp;&nbsp;</span
                  >
                </div>
                <br /><br /><br /><br />
                <!-- <div class="w-full p-2"></div> -->
              </div>
            </div>

            <div class="">
              <div class="px-8">
                <div style="line-height: 0.5">
                  <p class="mb-4">Sekian, Terima Kasih.</p>
                  <br /><br /><br />
                  <p>
                    <span class="mr-8"
                      ><b>Igeotech (M) SDN BHD. (746236-P)</b>
                    </span>
                  </p>

                  <br /><br /><br />
                </div>
                <p>
                  Dokumen in adalah dijana oleh komputer. Tandatangan adalah
                  tidak diperlukan
                </p>
              </div>
            </div>
            <div
              class="absolute left-0"
              style="
                width: 100%;
                height: 20px;
                background-color: #283490;
                color: white;
                text-align: center;
                bottom: 0px;
              "
            >
              <p>
                Suite 710, 7th Floor, Block B, Kelana Square, 17, Jalan SS7/26,
                Kelana Jaya, 47301 Petaling Jaya, Selangor , Malaysia
              </p>
            </div>
          </div>
        </section>
      </vue-html2pdf>
    </div>
  </vx-card>
</template>

<script setup>
import { ref, watch, onUnmounted } from 'vue';
import VueHtml2pdf from 'vue-html2pdf';
import AssetsSelect from '@/views/experimental/map-view/AssetsSelect.vue';
import { customCss } from '@/views/experimental/table-view/quasar.js';
import { useStyleTag } from '@vueuse/core';
const { id, css, load, unload } = useStyleTag(customCss, { id: 'nabuto' });

onUnmounted(() => {
  unload();
});

const html2Pdf = ref();

const loading = ref(false);
function generatePdf() {
  loading.value = true;
  setTimeout(() => {
    html2Pdf.value.generatePdf();
  }, 500);
}
const progress = ref(0);

function onProgress(v) {
  progress.value = v;
}

watch(progress, () => {
  if (progress.value == 100) {
    setTimeout(() => {
      progress.value = 0;
      loading.value = false;
    }, 50);
  }
});
</script>

<script>
import moment from 'moment';
import { MultiSelectPlugin } from '@syncfusion/ej2-vue-dropdowns';
import { load } from '@syncfusion/ej2-vue-grids';

export default {
  data() {
    return {
      isLoading: false,
      configPopup: false,
      todayDate: moment().format('Do MMMM YYYY'),
      unitSelection: JSON.parse(localStorage.getItem('unitSelection')),
      companyName: JSON.parse(
        localStorage.getItem('userInfo'),
      ).company.toUpperCase(),
      companyDetails: {
        name: 'Receipient Name',
        username: '-',
        pwd: '-',
      },
      fields: { groupBy: 'assetGroup', text: 'assetName', value: 'assetName' },
      selectedUnits: [],

      invoiceDetails: {
        invoiceNo: '001/2019',
        invoiceDate: 'Mon Dec 10 2018 07:46:00 GMT+0000 (GMT)',
      },
      invoiceData: {
        tasks: [
          {
            id: 1,
            task: 'CSL-BLA6910',
            hours: '2021-10-06 04:32:25',
            rate: 15,
            amount: 90000,
          },
          {
            id: 2,
            task: 'TOF-VAC8917',
            hours: '2021-10-06 04:32:25',
            rate: 12,
            amount: 24000,
          },
        ],
        subtotal: 114000,
        discountPercentage: 5,
        discountedAmount: 5700,
        total: 108300,
      },
    };
  },
  computed: {},
  methods: {
    openConfigPanel() {
      this.configPopup = true;
    },
    filtering(args) {
      const self = this;
      const searchData = self.unitSelection;
      let query = new Query();
      let predicate = new Predicate('assetName', 'contains', args.text, true);
      predicate = predicate.or('assetGroup', 'contains', args.text, true);
      query = args.text != '' ? query.where(predicate) : query;

      args.updateData(searchData, query);
    },
    generateReport() {
      const self = this;
      self.isLoading = true;
      self.$http
        .post('settings/printcertificate', {
          companyName: self.companyName,
          companyDetails: self.companyDetails,
          assets: self.selectedUnits,
        })
        .then(function (response) {
          self.isLoading = false;
          if (response.status == 200 && response.data.success) {
            self.$vs.notify({
              title: 'Success',
              text: 'Please disable popup blocker to download document. Certificate should open in new tab. ',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'success',
            });
            return window.open(response.data.pdflink);
          } else if (response.data.error) {
            return self.$vs.notify({
              title: 'Error',
              text: 'Could not download pdf at this moment',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'warning',
            });
          } else {
            return self.$vs.notify({
              title: 'Error',
              text: 'Could not download pdf at this moment',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'warning',
            });
          }
        })
        .catch(function (error) {
          return self.$vs.notify({
            title: 'Error',
            text: 'Could not download pdf at this moment',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning',
          });
        });
    },
  },
  components: {
    moment,
    MultiSelectPlugin,
  },
  mounted() {
    this.$emit('setAppClasses', 'invoice-page');
  },
};
</script>

<style lang="scss">
@media print {
  .invoice-page {
    * {
      visibility: hidden;
    }

    #content-area {
      margin: 0 !important;
    }

    .vs-con-table {
      .vs-con-tbody {
        overflow: hidden !important;
      }
    }

    #invoice-container,
    #invoice-container * {
      visibility: visible;
    }
    #invoice-container {
      position: absolute;
      left: 0;
      top: 0;
      box-shadow: none;
    }
  }
}

@page {
  size: auto;
}

@import '../../../../node_modules/@syncfusion/ej2-base/styles/material.css';
@import '../../../../node_modules/@syncfusion/ej2-inputs/styles/material.css';
@import '../../../../node_modules/@syncfusion/ej2-vue-dropdowns/styles/material.css';
@import '../../../../node_modules/@syncfusion/ej2-buttons/styles/material.css';
</style>
